import { timeBands } from '../../const/timeBands';
import { calculateAgeInMonths } from '@domgen/shared/utils/date/calculateAgeInMonths';
/**
 * @description Takes the purchase date (as Date object) and returns a purchase time band.
 * Age is calculated in whole calendar months via `calculateAgeInMonths` so this
 * stays aligned with server-side age logic.
 * @param {Date} purchaseDate - The date of purchase as a Date object.
 * @returns { 'Under 1 month' | '1 - 2 months' | '2 - 3 months' | '3 - 4 months' | '4 - 5 months' | '5 - 6 months' | '6 - 12 months' | '12 - 18 months' | '18 months +' | 'Unknown' } A string representing the time band of the purchase date.
 */
export function getPurchaseTimeBand(purchaseDate: Date) {
  if (!(purchaseDate instanceof Date) || Number.isNaN(purchaseDate.getTime())) {
    return 'Unknown';
  }

  const purchaseLocalDateString = `${purchaseDate.getFullYear()}-${String(
    purchaseDate.getMonth() + 1,
  ).padStart(2, '0')}-${String(purchaseDate.getDate()).padStart(2, '0')}`;
  const monthsDiff = calculateAgeInMonths(purchaseLocalDateString);

  if (monthsDiff < 0) {
    return 'Unknown';
  }

  const band = timeBands.find((band) => monthsDiff >= band.min && monthsDiff <= band.max);
  return band ? band.name : 'Unknown';
}
